const ProductsSection = () => {
  const products = [
    {
      id: 'inss',
      icon: 'ri-user-heart-line',
      title: 'Aposentados INSS',
      benefits: [
        'Até 40% de margem consignável',
        'Menor taxa do mercado',
        'Sem sair de casa',
      ],
      badge: 'A partir de 1,85% a.m.',
      description: 'Crédito especial para aposentados e pensionistas do INSS com desconto direto no benefício.',
      whatsappMessage: 'Olá! Quero saber mais sobre o consignado para aposentados INSS.',
    },
    {
      id: 'clt',
      icon: 'ri-briefcase-line',
      title: 'Servidores CLT',
      benefits: [
        'Desconto em folha de pagamento',
        'Aprovação facilitada',
        'Taxas reduzidas',
      ],
      badge: 'A partir de 3,83% a.m.',
      description: 'Empréstimo consignado para trabalhadores com carteira assinada e servidores públicos.',
      whatsappMessage: 'Olá! Quero saber mais sobre o Crédito CLT.',
    },
    {
      id: 'portabilidade',
      icon: 'ri-exchange-line',
      title: 'Portabilidade',
      benefits: [
        'Reduza sua parcela em até 40%',
        'Processo 100% digital',
        'Sem custo de transferência',
      ],
      badge: 'Economize agora',
      description: 'Transfira seu empréstimo para a Carbone e pague menos nas parcelas mensais.',
      whatsappMessage: 'Olá! Quero saber mais sobre Portabilidade de crédito.',
    },
    {
      id: 'refinanciamento',
      icon: 'ri-money-dollar-circle-line',
      title: 'Refinanciamento',
      benefits: [
        'Receba troco na conta',
        'Quite dívidas caras',
        'Parcelas menores',
      ],
      badge: 'Dinheiro extra',
      description: 'Refinancie seu contrato atual e receba a diferença em dinheiro na sua conta.',
      whatsappMessage: 'Olá! Quero saber mais sobre Refinanciamento de crédito.',
    },
    {
      id: 'cartoes',
      icon: 'ri-bank-card-line',
      title: 'Cartão Consignado',
      benefits: [
        'Limite pré-aprovado',
        'Desconto automático',
        'Sem anuidade',
      ],
      badge: 'Simule Agora',
      description: 'Cartão de crédito com desconto direto no benefício e limite garantido.',
      whatsappMessage: 'Olá! Quero saber mais sobre Cartão Consignado.',
    },
    {
      id: 'veiculos',
      icon: 'ri-car-line',
      title: 'Financiamento de Veículos',
      benefits: [
        'Taxas competitivas',
        'Novos e seminovos',
        'Aprovação rápida',
      ],
      badge: 'Realize seu sonho',
      description: 'Financie seu carro novo ou seminovo com as melhores condições do mercado.',
      whatsappMessage: 'Olá! Quero saber mais sobre Financiamento de Veículos.',
    },
    {
      id: 'imoveis',
      icon: 'ri-home-4-line',
      title: 'Financiamento de Imóveis',
      benefits: [
        'Até 35 anos para pagar',
        'Use seu FGTS',
        'Taxas especiais',
      ],
      badge: 'Casa própria',
      description: 'Realize o sonho da casa própria com financiamento imobiliário facilitado.',
      whatsappMessage: 'Olá! Quero saber mais sobre Financiamento de Imóveis.',
    },
    {
      id: 'agricola',
      icon: 'ri-plant-line',
      title: 'Crédito Agrícola',
      benefits: [
        'Custo e investimento',
        'Carência especial',
        'Taxas subsidiadas',
      ],
      badge: 'Para o produtor',
      description: 'Crédito rural para custeio, investimento e comercialização da sua produção.',
      whatsappMessage: 'Olá! Quero saber mais sobre Crédito Agrícola.',
    },
  ];

  return (
    <section className="py-24 bg-white" id="produtos">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-gold-500 font-semibold text-sm uppercase tracking-wide">
            Nossos Produtos
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-navy-900 mt-3 mb-4">
            Crédito para cada necessidade
          </h2>
          <p className="text-xl text-navy-600 max-w-3xl mx-auto">
            Soluções financeiras personalizadas para aposentados, pensionistas, servidores públicos, trabalhadores CLT e produtores rurais
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-product-shop>
          {products.map((product) => (
            <div
              key={product.id}
              id={product.id}
              className="bg-white border-2 border-navy-100 rounded-2xl p-6 transition-all duration-300 hover:border-gold-400 hover:shadow-2xl hover:-translate-y-2 cursor-pointer group"
            >
              <div className="w-14 h-14 bg-navy-900 rounded-xl flex items-center justify-center mb-5 group-hover:bg-gold-500 transition-colors">
                <i className={`${product.icon} text-2xl text-gold-400 group-hover:text-navy-900`}></i>
              </div>

              <h3 className="text-xl font-bold text-navy-900 mb-2">{product.title}</h3>
              <p className="text-navy-600 text-sm mb-4 leading-relaxed">{product.description}</p>

              <ul className="space-y-2 mb-4">
                {product.benefits.map((benefit, index) => (
                  <li key={index} className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-fill text-gold-500 text-base mt-0.5"></i>
                    <span className="text-navy-700 text-sm">{benefit}</span>
                  </li>
                ))}
              </ul>

              <div className="bg-gold-50 text-gold-700 px-3 py-2 rounded-lg text-center font-semibold text-sm mb-4 border border-gold-200">
                {product.badge}
              </div>

              <a
                href={`https://wa.me/5519971344445?text=${encodeURIComponent(product.whatsappMessage)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full text-center border-2 border-navy-200 hover:border-gold-500 hover:bg-gold-50 text-navy-700 hover:text-gold-700 font-semibold py-3 rounded-lg transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                Falar com um especialista
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;
